import {graphql, HeadProps, Link, PageProps} from 'gatsby';
import moment from 'moment';
import * as React from 'react';

import ArticlePreview from '_components/ArticlePreview';
import Layout from '_components/layout';
import SEO from '_components/SEO';
import SunnyPortableText from '_components/SunnyPortableText';
import SunnyTrust from '_sections/sunnyTrust';

export default function Article(props: PageProps<Queries.ArticleDetailQuery>) {
  const article = props.data.sanityArticle;
  const latestArticles = props.data.latestArticles;
  const sameCategoryArticle = props.data.sameCategoryArticles;
  return (
    <Layout>
      <div className="max-w-section mx-auto px-4 lg:px-20 mt-20 ">
        <div className="flex gap-x-20 flex-col lg:flex-row">
          <div className="w-full max-w-[840px] px-2">
            <div className="text-28 font-bold">{article?.title}</div>
            <div className="mt-4">
              <span className="text-sm font-medium">
                {moment(article?.publishDate).format('D MMMM Y')}
              </span>
              <span className="mx-3 text-gray-300">|</span>
              <Link
                className="text-primay"
                to={`/articles?categoryId=${article?.category?.id}`}>
                {article?.category?.name}
              </Link>
            </div>
            <div className="mt-8">{article?.summary}</div>
            <div className="mt-4">
              <div
                className="fb-like"
                data-href="https://developers.facebook.com/docs/plugins/"
                data-width=""
                data-layout="button_count"
                data-action=""
                data-size=""
                data-share="false"></div>
            </div>
            <div className="mt-4">
              <SunnyPortableText value={article?._rawBody} />
            </div>
          </div>
          <div className="mt-12 lg:mt-0">
            <div className="font-bold text-xl">Latest Articles</div>
            <div className="flex flex-row lg:flex-col justify-start lg:justify-between mt-4 lg:mt-8 gap-y-8 gap-x-4 lg:gap-x-0 overflow-x-scroll hide-scrollbar -mr-4 pr-4">
              {latestArticles.edges.map(edge => (
                <ArticlePreview
                  key={edge.node.id}
                  item={edge.node}
                  mobileSize="small"
                />
              ))}
            </div>
          </div>
        </div>
        {sameCategoryArticle.edges.length > 0 ? (
          <div className="mt-12 lg:mt-40">
            <div className="font-bold text-xl">
              More from "{article?.category?.name}"
            </div>
            <div className="flex justify-start lg:justify-between mt-4 lg:mt-8 gap-y-8 gap-x-4 lg:gap-x-0 overflow-x-scroll hide-scrollbar -mr-4 pr-4">
              {sameCategoryArticle.edges.map(edge => (
                <ArticlePreview
                  key={edge.node.id}
                  item={edge.node}
                  mobileSize="small"
                />
              ))}
            </div>
          </div>
        ) : null}
      </div>
      <div className="bg-[#f5f5f5] mt-16 lg:mt-48">
        <SunnyTrust />
      </div>
    </Layout>
  );
}
export const Head = (props: HeadProps<Queries.ArticleDetailQuery>) => (
  <>
    <title>{props.data.sanityArticle?.title}</title>

    <SEO
      title={
        props.data.sanityArticle?.seoTitle || props.data.sanityArticle?.title
      }
      description={
        props.data.sanityArticle?.seoDescription ||
        props.data.sanityArticle?.summary
      }
    />
  </>
);

export const query = graphql`
  query ArticleDetail($id: String, $categoryId: String) {
    sanityArticle(id: {eq: $id}) {
      id
      title
      publishDate
      summary
      seoTitle
      seoDescription
      category {
        id
        name
      }
      _rawBody(resolveReferences: {maxDepth: 5})
    }
    latestArticles: allSanityArticle(
      filter: {id: {ne: $id}}
      sort: {_createdAt: DESC}
      limit: 3
    ) {
      edges {
        node {
          ...ArticlePreviewInfo
        }
      }
    }
    sameCategoryArticles: allSanityArticle(
      filter: {id: {ne: $id}, category: {id: {eq: $categoryId}}}
      sort: {_createdAt: DESC}
      limit: 3
    ) {
      edges {
        node {
          ...ArticlePreviewInfo
        }
      }
    }
  }
`;
